let resizeTimer,
    bLazyBanner;

$.fn.overflown = function () {
    var e = this[0]; return e.scrollHeight > e.clientHeight || e.scrollWidth > e.clientWidth;
}

function checkResolution(query) {
    let active = false;

    if (!query) {
        return true;
    }

    for (let value of query.split(";")) {
        if ($(".c-var ." + value + "-is-visible").is(":visible")) {
            active = true;
        }
    }

    return active;
}

function floatingBoxInit(options) {
    const $box = $(options.box),
        $boxWrapper = $(options.wrapper);

    if (!$box.length || !$boxWrapper.length) {
        return false;
    }

    floatingBoxFloat($box, $boxWrapper, options);

    $(window).on('scroll resize', function () {
        floatingBoxFloat($box, $boxWrapper, options);
    });
}

function floatingBoxFloat($box, $boxWrapper, options) {
    if (checkResolution(options.query || true)) {
        const windowTopOffset = $(document).scrollTop(),
            boxWrapperTopOffset = $boxWrapper.offset().top,
            boxWrapperHeight = $boxWrapper.outerHeight(),
            boxHegiht = $box.height(),
            scrollOffset = 30,

            // Scroll okna plus offset elementu od vrcho pri scrolle v pixeloch
            boxStartScroll = windowTopOffset + scrollOffset,
            // odsadenie elementu od vrchu plus vyska wrapperu minus vyska floatovacieho okna
            boxEndScroll = boxWrapperTopOffset + boxWrapperHeight - boxHegiht - 100;

        // Ak je scroll okna vacsi ako vrchna pozicia wrapperu floatovacieho boxu
        // a zaroven je scroll okna mensi ako vrchna pozicia wrapperu floatovacieho boxu
        // plus celkova velkost wrapperu floatovacieho okna minus velkost floatovacieho okna
        // vtedy sa prida position fixed
        if (boxStartScroll > boxWrapperTopOffset && boxStartScroll < boxEndScroll) {
            if (!$box.hasClass('is-fixed')) {
                $box.css('top', scrollOffset);
                $box.addClass('is-fixed');
            }

            // Ak je scroll okna vacsi ako finalna scrollovacia poziciia vtedy sa floatovaci box
            // posunie uplne na spodok wrapperu
        } else if (boxStartScroll > boxEndScroll) {
            if ($box.hasClass('is-fixed')) {
                $box.css('top', boxEndScroll - boxWrapperTopOffset);
                $box.removeClass('is-fixed');
            }

            // Ak je scroll okna mensi ako vrchna pozicia wrapper, vtedy sa floatovaci box posunie
            // uplne na vrch wrapperu
        } else if (boxStartScroll < boxWrapperTopOffset) {
            if ($box.hasClass('is-fixed')) {
                $box.css('top', boxWrapperTopOffset - boxWrapperTopOffset);
                $box.removeClass('is-fixed');
            }
        }
    } else {
        $box.removeClass('is-fixed').css('top', '');
    }
}

RshopApp.$mount('.l-base');

$('.modal').on('show.bs.modal', function() {
    setTimeout(function() {
        freezeScroll();
    }, 0);
});

$('.modal').on('hidden.bs.modal', function() {
    unfreezeScroll();
});

function renderMultiselect() {
    $('.js-select').not('.is-loaded').each(function () {
        let $select = $(this),
            classes = '';

        if ($select.hasAttr('data-class')) {
            classes = ' ' + $select.data('class');
        }

        $select.multiselect({
            enableHTML: true,
            templates: {
                button: '<button type="button" class="multiselect dropdown-toggle" data-toggle="dropdown"><span class="multiselect-selected-text"></span><i class="ico ico-chevron-down"></i></button>'
            },
            buttonClass: 'c-btn has-icon' + classes
        });

        $select.addClass('is-loaded');
    });

    $('.js-select-order').not('.is-loaded').multiselect({
        templates: {
            button: '<button type="button" class="multiselect dropdown-toggle" data-toggle="dropdown"><span class="multiselect-selected-text"></span><i class="ico ico-chevron-down"></i></button>'
        },
        buttonClass: 'c-btn has-icon',
        enableHTML: true,
        buttonText: function(options, select) {
            const $orderSelect = $('.js-select-order'),
                selectedValue = $(options).text(),
                emptyTitle = $orderSelect.data('empty-title'),
                isFiltered = $orderSelect.data('is-filtered'),
                isLoaded = $orderSelect.hasClass('is-loaded');

            let buttonTitle = selectedValue;

            if (!isLoaded && !isFiltered) {
                buttonTitle = emptyTitle;
            }

            return buttonTitle;
        }
    });
    $('.js-select-order').addClass('is-loaded');
}

function calculateViewportUnits() {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
}

function checkMaxLines() {
    $('.js-maxlines').each(function() {
        if ($(this).overflown()) {
            $(this).addClass('is-truncated');
        } else {
            $(this).removeClass('is-truncated');
        }
    });
}

function resetCaptchas() {
    $('.g-recaptcha').each(function(index) {
        grecaptcha.reset(index);
    });
}

function showMaxQuantityMessage(input) {
    const $productBuy = $(input).closest('.js-product-buy'),
        message = $productBuy.data('max-message'),
        id = $productBuy.data('id');

    if (!$productBuy.length) {
        return;
    }

    Eshop.alert(message, {
        type: 'error',
        uniqueClass: `quantity-${id}`
    });
}

$(function() {
    if (checkResolution('ie')) {
        objectFitImages();

        bLazy.options.success = function(ele) {
            objectFitImages(ele);
        }
    }

    calculateViewportUnits();
    checkMaxLines();

    $(window).on('resize', function(e) {
        clearTimeout(resizeTimer);

        resizeTimer = setTimeout(function() {
            Event.dispatch('Window.resized');

            bLazy.revalidate();
            calculateViewportUnits();
            checkMaxLines();
        }, 250);
    });

    $('.js-remote-modal').on('hidden.bs.modal', function() {
        $(this).removeClass('is-loaded');
    });

    renderMultiselect();

    $('.js-testimonials-trigger-description').on('click', function() {
        const $shortDesc = $(this).closest('.js-testimonials-short-description'),
            $fullDesc = $shortDesc.siblings('.js-testimonials-full-description');

        $shortDesc.remove();
        $fullDesc.removeClass('h-nodisplay');
    });

    $('.js-anchor').on('click', function (event) {
        event.preventDefault();

        let href = $(this).attr('href');

        if (!href) {
            href = $(this).data('href');
        }

        if (!href) {
            return false;
        }

        slideTo($(href), 25, 300);
    });

    bLazyBanner = new Blazy({
        selector: '.js-blazy-banner',
        successClass: 'is-loaded',
        offset: $(window).height() / 2,
        breakpoints: [{
            width: 599,
            src: 'data-src-600'
        }],
        success: function(ele) {
            var url = $(ele).css('background-image');

            ele.style.setProperty('background-image', url, 'important');
        }
    });

    $(document).on('spin', 'input.ui-spinner-input', function (e, ui) {
        const $spinnerInput = $(this),
            max = parseInt($spinnerInput.attr('max')),
            value = parseInt(ui.value) || 1;

        if (value > max) {
            showMaxQuantityMessage(this);
        }
    });

    $(document).on('spinchange blur', 'input.ui-spinner-input', function (e, ui) {
        const $spinnerInput = $(this),
            max = parseInt($spinnerInput.attr('max')),
            min = parseInt($spinnerInput.attr('min'));

        let value = parseInt($spinnerInput.val());

        if (isNaN(value)) {
            value = 1;
        }

        if (value > max) {
            value = max;

            showMaxQuantityMessage(this);
        }

        if (value < min) {
            value = min;
        }

        $spinnerInput.val(value);
    });
})
